export const DEGREES = [
  'Licenciatura', 'Maestría', 'Doctorado'
]